/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {useEffect, useState} from 'react'

const mappedLabel = (label: string, index: number) => {
  if (label === '&laquo; Previous') {
    return 'Previous'
  }

  if (label === 'Next &raquo;') {
    return 'Next'
  }

  return index + 1
}

const UsersListPagination = ({total, page, updatePage, recordsPerPage, rowsPerPage}: any) => {
  const [pagePerItem, setPagePerItem] = useState<number>(0)
  const [collection, setCollection] = useState([])
  useEffect(() => {
    const _pagePerItem = Math.ceil(total / rowsPerPage)
    setPagePerItem(_pagePerItem)
    const pages: any = []
    for (let i = 0; i < _pagePerItem; i++) {
      pages.push(i)
    }

    setCollection(pages)
  }, [total, rowsPerPage])

  const onPageChange = (e: any) => {
    recordsPerPage(e.target.value)
    updatePage(0)
  }
  return (
    <div className='row'>
      <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>
        <span>
          <select
            className='form-select form-select-solid'
            aria-label='Select example'
            value={String(rowsPerPage)}
            onChange={(e) => onPageChange(e)}
          >
            <option value={"10"}>10</option>
            <option value={"50"}>50</option>
            <option value={"100"}>100</option>
          </select>
        </span>
      </div>
      <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
        <div id='kt_table_users_paginate'>
          <ul className='pagination'>
            <li className={'page-item'}>
              <a
                className={clsx('page-link')}
                style={{cursor: 'pointer'}}
                onClick={() => {
                  if (page !== 0) {
                    updatePage(page - 1)
                  } else {
                    return
                  }
                }}
              >
                <i className='previous'></i>
              </a>
            </li>
            {collection.map((item: any, index: number) => (
              <li
                key={index}
                className={clsx('page-item', {
                  active: index === page,
                  // disabled: isLoading,
                  previous: true,
                  next: true,
                })}
              >
                <a
                  className={clsx('page-link')}
                  onClick={() => updatePage(index)}
                  style={{cursor: 'pointer'}}
                >
                  {mappedLabel(item.label, index)}
                </a>
              </li>
            ))}
            <li className={'page-item'}>
              <a
                className={clsx('page-link')}
                style={{cursor: 'pointer'}}
                onClick={() => {
                  if (page !== pagePerItem - 1) {
                    updatePage(page + 1)
                  } else {
                    return
                  }
                }}
              >
                <i className='next'></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export {UsersListPagination}
